import { SsoType } from '@diritto/common/account/constants/sso.constant';

export const InAppEventName = 'DirittoInAppEvent';

export interface InAppEvent<I extends InAppEventType> extends Event {
  type: I;
  message: InAppEventParams[I];
}

export enum InAppEventType {
  SignWithSsoAccessToken = 'SignWithSsoAccessToken',
  ChangePushOn = 'ChangePushOn',
  Action = 'Action',
  VolumeBtnPressed = 'VolumeBtnPressed',
}

export enum ActionType {
  Save = 'Save',
  Register = 'Register',
  Share = 'Share',
}

export type AccessTokenType = { ssoAccessToken: string };

export interface InAppEventParams {
  [InAppEventType.SignWithSsoAccessToken]: { ssoType: SsoType; isForLink: boolean } & AccessTokenType;
  [InAppEventType.ChangePushOn]: { isPushOn: boolean };
  [InAppEventType.Action]: { type: ActionType };
  [InAppEventType.VolumeBtnPressed]: { key: 'VOLUME_UP' | 'VOLUME_DOWN' };
}
